// extracted by mini-css-extract-plugin
export default {"addedUsersList":"AddPeopleDialog_addedUsersList__S5Ln+","footer":"AddPeopleDialog_footer__fb8ke","paper":"AddPeopleDialog_paper__uPnfv"};